import { omit } from 'lodash'
import { SortDirection } from 'material/MuiTable'

import { premiumColumns } from 'routes/highschools/ExploreTable/columns'
import {
  UIFilterConverters,
  URLStateConverter,
  decodeFromURLParams,
  encodeToURLParams,
} from 'routes/highschools/filter-state-to-url-params'
import {
  PageSizeOption,
  SortKey,
  UIFilters,
  isValidPageSizeOption,
  isValidSortKey,
  stringAsSortDirection,
} from 'routes/highschools/types'

type ViewQueryParams = {
  pageSize?: PageSizeOption
  sortDir?: SortDirection
  sort?: SortKey
  currentPage?: number
}

const paramToInt = (v?: string): number | undefined => {
  const int = v ? parseInt(v) : undefined
  return !int || isNaN(int) ? undefined : int
}

export type ViewQueryState = ViewQueryParams & UIFilters
export const ViewQueryStateConverters: {
  [TKey in keyof ViewQueryState]-?: URLStateConverter<ViewQueryState[TKey]>
} = {
  ...UIFilterConverters,
  pageSize: {
    encode: (v) => (v !== undefined ? v.toString() : undefined),
    decode: (v?: string[]) => {
      if (v?.length !== 1) return
      const val = parseInt(v[0])
      if (isValidPageSizeOption(val)) return val
      return
    },
  },
  currentPage: {
    encode: (v) => (v !== undefined ? v.toString() : undefined),
    decode: (v?: string[]) => paramToInt(v?.[0]),
  },
  sortDir: {
    encode: (v) => v?.toString(),
    decode: (v?: string[]) => stringAsSortDirection(v?.[0]),
  },
  sort: {
    encode: (v) => v?.toString(),
    decode: (v?: string[]) => {
      if (!isValidSortKey(v?.[0])) return
      return v?.[0]
    },
  },
}

export const decodeViewsQueryParams = (params: URLSearchParams): ViewQueryState => {
  return decodeFromURLParams(params, ViewQueryStateConverters)
}

export const encodeViewQueryParams = (state: ViewQueryState, initialParams?: URLSearchParams): URLSearchParams => {
  return encodeToURLParams(state, ViewQueryStateConverters, initialParams)
}

export const convertViewQueryStateToUIFilters = (
  state: ViewQueryState,
  isPremiumExplorerEnabled: boolean,
): UIFilters => {
  const { pageSize, sortDir, sort, currentPage, ...filters } = state
  const filteredFilters = isPremiumExplorerEnabled ? filters : omit(filters, premiumColumns)
  return filteredFilters
}
